/*global swal*/

import './style.less';
import editTagModalTemplate from 'modals/editTag/template.html';
import editTagModalCtrl from 'modals/editTag';

export default function($log, $stateParams, $uibModal, ProfileClass, ApiClass, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.formData = {};
  vm.submitButton = false;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.allowedItemTypesList = [
    { id: 'activities', name: 'Activities' },
    { id: 'bundles', name: 'Bundles' },
    { id: 'courses', name: 'Courses' },
    { id: 'events', name: 'Events' },
    { id: 'learningTracks', name: 'Learning Tracks' },
    { id: 'profiles', name: 'Profiles' },
    { id: 'teams', name: 'Teams' }
  ];

  vm.delete = tag => {
    Swal.confirm('Delete Option?', `This will remove the option "${tag.name}".`)
      .then(() => {
        return ApiClass.companiesIdTypeTypeIdDelete({
          manage: true,
          id: company_id,
          type: 'tags',
          type_id: tag.uuid
        });
      })
      .then(() => {
        _toast('Option Deleted!');
        tag.archived = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.add = name => {
    vm.laddaAdd = true;
    ApiClass.companiesIdTypePut(
      { manage: true, id: company_id, type: 'tags' },
      {
        name,
        parentId: $stateParams.type_id,
        active: true
      }
    )
      .then(({ data: { item } }) => {
        vm.tags.push(item);
        _cleanForm();
        vm.laddaAdd = false;
      })
      .catch(error => {
        vm.laddaAdd = false;
        $log.error(error);
        throw error;
      });
  };

  vm.edit = tag => {
    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: editTagModalTemplate,
        controller: editTagModalCtrl,
        controllerAs: 'editTagModalCtrl',
        resolve: {
          tag: () => tag
        }
      })
      .result.then(response => {
        if (response === 'cancel') return;
        _toast('Option Updated!');
        activate();
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;

        $log.error(error);
        throw error;
      });
  };

  vm.updateStatus = (tag, active) => {
    ApiClass.companiesIdTypeTypeIdPatch(
      {
        manage: true,
        id: company_id,
        type: 'tags',
        type_id: tag.uuid
      },
      { active }
    )
      .then(() => {
        _toast('Option Updated!');
        tag.active = active;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.submit = formData => {
    vm.submitButton = true;
    ApiClass.companiesIdTypeTypeIdPatch(
      {
        manage: true,
        id: company_id,
        type: 'tagCategories',
        type_id: $stateParams.type_id
      },
      formData
    )
      .then(() => {
        _toast('Category information has been saved');
        activate();
        vm.submitButton = false;
      })
      .catch(error => {
        vm.submitButton = false;
        $log.error(error);
        throw error;
      });
  };

  function _toast(message) {
    Swal.toast(message);
  }

  function _loadTagCategory() {
    return ApiClass.companiesIdTypeTypeIdGet({
      manage: true,
      id: company_id,
      type: 'tagCategories',
      type_id: $stateParams.type_id
    })
      .then(({ data: { item: { tagCategory, tags } } }) => {
        vm.formData = tagCategory;
        vm.tags = Object.values(tags);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }

  function _cleanForm() {
    delete vm.name;
    vm.tagForm.$setPristine();
    vm.tagForm.$setUntouched();
    vm.tagFormSubmitted = false;
  }

  function activate() {
    $log.debug('teams Controller Activated');
    _loadTagCategory();
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/settings/tags/edit/index.js